var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BCXMarkdown',{staticClass:"bcx-centered-text",attrs:{"text":_vm.$t('login.'+(_vm.isFinal ? 'bye_final' : 'bye')),"unstyled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }